import { render } from "./NewTrades.vue?vue&type=template&id=213db2ac"
import script from "./NewTrades.vue?vue&type=script&lang=js"
export * from "./NewTrades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__